(() => {
  const selector = 'button.bgm, button#music.music';
  const note = '<path d="M11.5 18.2V3.5c1.8 3 5.5 3.6 5.5 7.2 0 1.9-1.1 3.5-2.4 4.3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><ellipse cx="8.9" cy="18.3" rx="3" ry="1.9" transform="rotate(-35 8.9 18.3)" fill="currentColor"/>';
  function update(button) {
    const muted = button.getAttribute('aria-pressed') === 'true';
    const state = muted ? 'off' : 'on';
    if (button.querySelector('svg')?.getAttribute('data-video-music-note') === state) return;
    button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" data-video-music-note="' + state + '" style="width:28px!important;height:28px!important;flex:none">' + note + (muted ? '<path d="M4 4l16 16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' : '') + '</svg>';
  }
  const pending = new Set();
  let scheduled = false;
  function queue(button) {
    pending.add(button);
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      for (const item of pending) if (item.isConnected) update(item);
      pending.clear();
    });
  }
  function scan(node) {
    if (!(node instanceof Element)) return;
    const button = node.closest(selector);
    if (button) queue(button);
    for (const item of node.querySelectorAll(selector)) queue(item);
  }
  function start() {
    for (const button of document.querySelectorAll(selector)) update(button);
    new MutationObserver(records => {
      for (const record of records) {
        const button = record.target instanceof Element && record.target.closest(selector);
        if (button) queue(button);
        if (record.type === 'childList') for (const node of record.addedNodes) scan(node);
      }
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-pressed'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
